/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import { Component, Input } from '@angular/core';
import { customTemplates } from 'ng/modules/logs/constants/logs-signpost.constants';
import { TrafficLogsSignpostStore } from '../../traffic-logs/traffic-logs-sidebar/traffic-logs-signpost.store';
import './logs-signpost-custom.component.less';

/**
 * @description
 *     Component for displaying custom signpost templates of traffic logs.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost-custom',
    templateUrl: './logs-signpost-custom.component.html',
})
export class LogsSignpostCustomComponent {
    public readonly customTemplates = customTemplates;

    /**
     * The ID of the pool used to filter logs from a VS.
     */
    @Input()
    public poolId?: string;

    constructor(public readonly trafficLogsSignpostStore: TrafficLogsSignpostStore) {}
}
